import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext'; // Update path if needed
import { buildUrlWithParams } from './utils.js'; // Update path if needed
import './UserCardOrganizer.no-dnd.css'; // Update path if needed
import { Dropdown, Form, Button, Modal, InputGroup, ListGroup, Alert, Spinner } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { FaFilter, FaCalendarAlt, FaTimes, FaCog, FaPlus, FaTrash, FaEdit, FaSave, FaUndo, FaFolder, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { BsGripVertical } from 'react-icons/bs';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ActiveFilters from './ActiveFilters'; // Update path if needed
import Pagination from './Pagination'; // Update path if needed

// --- FiltersDropdown Component (Unchanged) ---
const FiltersDropdown = ({ currentFilters, onFilterChange, onResetFilters }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState(currentFilters.search || '');
  const searchInputRefDropdown = useRef(null);
  const [localDateRange, setLocalDateRange] = useState({ startDate: currentFilters.startDate ? new Date(currentFilters.startDate) : null, endDate: currentFilters.endDate ? new Date(currentFilters.endDate) : null, key: 'selection' });
  useEffect(() => { setLocalSearchTerm(currentFilters.search || ''); setLocalDateRange({ startDate: currentFilters.startDate ? new Date(currentFilters.startDate) : null, endDate: currentFilters.endDate ? new Date(currentFilters.endDate) : null, key: 'selection' }); }, [currentFilters]);
  const cardTypes = [ { label: "All Types", value: "" }, { label: "Minion", value: "Minion" }, { label: "Spell", value: "Spell" }, { label: "Weapon", value: "Weapon" }, { label: "Location", value: "Location" }, { label: "Hero", value: "Hero" }, { label: "Hero Card", value: "Herocard" }];
  const classes = [ { label: "All Classes", value: "" }, { label: "Death Knight", value: "DeathKnight" }, { label: "Demon Hunter", value: "Demon Hunter" }, { label: "Druid", value: "Druid" }, { label: "Hunter", value: "Hunter" }, { label: "Mage", value: "Mage" }, { label: "Paladin", value: "Paladin" }, { label: "Priest", value: "Priest" }, { label: "Rogue", value: "Rogue" }, { label: "Shaman", value: "Shaman" }, { label: "Warlock", value: "Warlock" }, { label: "Warrior", value: "Warrior" }, { label: "Neutral", value: "Neutral" }];
  const costs = [ { label: "Any Cost", value: "" }, ...Array.from({length: 11}, (_, i) => ({label: i === 10 ? "10+" : String(i), value: String(i)})) ];
  const rarities = [ { label: "All Rarities", value: "" }, { label: "Free", value: "Free" }, { label: "Common", value: "Common" }, { label: "Rare", value: "Rare" }, { label: "Epic", value: "Epic" }, { label: "Legendary", value: "Legendary" }];
  const orders = [ { label: "Date Added (Newest)", value: "date_desc" }, { label: "Date Added (Oldest)", value: "date_asc" }, { label: "Cost (High)", value: "cost_desc" }, { label: "Cost (Low)", value: "cost_asc" }];
  const handleSimpleFilterChange = (name, value) => { onFilterChange({ ...currentFilters, search: localSearchTerm, [name]: value }); };
  const handleSearchInputChange = (e) => { setLocalSearchTerm(e.target.value); };
  const triggerSearchFilter = () => { onFilterChange({ ...currentFilters, search: localSearchTerm }); };
  const handleSearchInputBlur = () => { if (localSearchTerm !== currentFilters.search) { triggerSearchFilter(); } };
  const handleSearchFormSubmit = (e) => { e.preventDefault(); triggerSearchFilter(); searchInputRefDropdown.current?.blur(); };
  const clearLocalSearch = () => { setLocalSearchTerm(''); onFilterChange({ ...currentFilters, search: '' }); searchInputRefDropdown.current?.focus(); };
  const handleDateChange = (ranges) => { const { selection } = ranges; setLocalDateRange(selection); };
  const applyDateRange = () => { onFilterChange({ ...currentFilters, search: localSearchTerm, startDate: localDateRange.startDate ? localDateRange.startDate.toISOString().split('T')[0] : '', endDate: localDateRange.endDate ? localDateRange.endDate.toISOString().split('T')[0] : '' }); setShowDatePicker(false); };
  const clearDateRange = () => { setLocalDateRange({ startDate: null, endDate: null, key: 'selection' }); onFilterChange({ ...currentFilters, search: localSearchTerm, startDate: '', endDate: '' }); };
  const handleDropdownClick = (e) => { e.stopPropagation(); };
  return ( <> <Dropdown.Menu className="filters-dropdown-menu p-3 shadow" onClick={handleDropdownClick}> <Form onSubmit={handleSearchFormSubmit} className="mb-3"> <Form.Label htmlFor="dropdownSearch" className="visually-hidden">Search</Form.Label> <InputGroup className="search-input-group-dropdown"> <Form.Control id="dropdownSearch" ref={searchInputRefDropdown} type="search" placeholder="Search in folder..." value={localSearchTerm} onChange={handleSearchInputChange} onBlur={handleSearchInputBlur} className="search-input-dropdown"/> {localSearchTerm && (<Button variant="link" onClick={clearLocalSearch} className="search-clear-btn-dropdown" aria-label="Clear search"><FaTimes /></Button>)} </InputGroup> </Form> <div className="filter-section"><h6 className="filter-section-title">Card Type</h6><Dropdown><Dropdown.Toggle variant="outline-secondary" size="sm" className="w-100 text-start dropdown-filter-toggle">{cardTypes.find(o => o.value === (currentFilters.cardtype || ""))?.label || "All Types"}</Dropdown.Toggle><Dropdown.Menu>{cardTypes.map(opt => ( <Dropdown.Item key={`ct-${opt.value}`} onClick={() => handleSimpleFilterChange('cardtype', opt.value)}> {opt.label} </Dropdown.Item> ))}</Dropdown.Menu></Dropdown></div> <div className="filter-section mt-2"><h6 className="filter-section-title">Class</h6><Dropdown><Dropdown.Toggle variant="outline-secondary" size="sm" className="w-100 text-start dropdown-filter-toggle">{classes.find(o => o.value === (currentFilters.class || ""))?.label || "All Classes"}</Dropdown.Toggle><Dropdown.Menu>{classes.map(opt => ( <Dropdown.Item key={`cl-${opt.value}`} onClick={() => handleSimpleFilterChange('class', opt.value)}> {opt.label} </Dropdown.Item> ))}</Dropdown.Menu></Dropdown></div> <div className="filter-section mt-2"><h6 className="filter-section-title">Cost</h6><Dropdown><Dropdown.Toggle variant="outline-secondary" size="sm" className="w-100 text-start dropdown-filter-toggle">{costs.find(o => o.value === (currentFilters.cost || ""))?.label || "Any Cost"}</Dropdown.Toggle><Dropdown.Menu>{costs.map(opt => ( <Dropdown.Item key={`co-${opt.value}`} onClick={() => handleSimpleFilterChange('cost', opt.value)}> {opt.label} </Dropdown.Item> ))}</Dropdown.Menu></Dropdown></div> <div className="filter-section mt-2"><h6 className="filter-section-title">Rarity</h6><Dropdown><Dropdown.Toggle variant="outline-secondary" size="sm" className="w-100 text-start dropdown-filter-toggle">{rarities.find(o => o.value === (currentFilters.rarity || ""))?.label || "All Rarities"}</Dropdown.Toggle><Dropdown.Menu>{rarities.map(opt => ( <Dropdown.Item key={`ra-${opt.value}`} onClick={() => handleSimpleFilterChange('rarity', opt.value)}> {opt.label} </Dropdown.Item> ))}</Dropdown.Menu></Dropdown></div> <div className="filter-section mt-2"><h6 className="filter-section-title">Order By</h6><Dropdown><Dropdown.Toggle variant="outline-secondary" size="sm" className="w-100 text-start dropdown-filter-toggle">{orders.find(o => o.value === (currentFilters.order || "date_desc"))?.label || "Date Added (Newest)"}</Dropdown.Toggle><Dropdown.Menu>{orders.map(opt => ( <Dropdown.Item key={`or-${opt.value}`} onClick={() => handleSimpleFilterChange('order', opt.value)}> {opt.label} </Dropdown.Item> ))}</Dropdown.Menu></Dropdown></div> <Dropdown.Divider className="my-3"/> <Button variant="danger" size="sm" onClick={() => { setLocalSearchTerm(''); onResetFilters(); }} className="w-100">Reset All Filters</Button> </Dropdown.Menu> <Modal show={showDatePicker} onHide={() => setShowDatePicker(false)} centered dialogClassName="rdr-modal"> <Modal.Header closeButton><Modal.Title>Select Date Range</Modal.Title></Modal.Header> <Modal.Body className="rdr-modal-body"><DateRangePicker ranges={[localDateRange.startDate && localDateRange.endDate ? localDateRange : { startDate: new Date(), endDate: new Date(), key: 'selection' }]} onChange={handleDateChange} months={1} direction="vertical" scroll={{ enabled: true }} showDateDisplay={false} minDate={new Date('2014-01-01')} maxDate={new Date()}/></Modal.Body> <Modal.Footer><Button variant="outline-secondary" onClick={clearDateRange}>Clear</Button><Button variant="secondary" onClick={() => setShowDatePicker(false)}>Cancel</Button><Button variant="primary" onClick={applyDateRange}>Apply</Button></Modal.Footer> </Modal> </> );};

// --- CardDisplay Component (Unchanged) ---
const CardDisplay = ({ card, onMoveClick, isSelected, onSelectChange }) => { const [isLoading, setIsLoading] = useState(true); const location = useLocation(); useEffect(() => { if (!card) return; const img = new Image(); const imgSrc = `/cards/${card.cardid}.${card.format}`; img.src = imgSrc; img.onload = () => setIsLoading(false); img.onerror = () => { setIsLoading(false); console.error("Failed to load image:", imgSrc); }; }, [card]); if (!card) { return <div className="card-item card-item--placeholder" style={{width: '150px', height: '210px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Loading Card...</div>; } const handleMoveIconClick = (e) => { e.preventDefault(); e.stopPropagation(); onMoveClick(card); }; const handleCheckboxChange = (e) => { onSelectChange(card.id); }; const handleLabelClick = (e) => { e.stopPropagation();  }; const linkToParams = { ...Object.fromEntries(new URLSearchParams(location.search)) }; if (card && card.id) { linkToParams.selectedCard = card.id; } else { delete linkToParams.selectedCard; } const cardLink = buildUrlWithParams(linkToParams); const checkboxId = `select-card-${card.id}`; return ( <div className={`card-item ${isSelected ? 'card-item--selected' : ''}`}> <label htmlFor={checkboxId} className="card-item__select-label" onClick={handleLabelClick} > <input type="checkbox" id={checkboxId} checked={!!isSelected} onChange={handleCheckboxChange} onClick={(e) => e.stopPropagation()} className="card-item__select-checkbox" aria-label={`Select card ${card.cardname || 'Unnamed Card'}`} title="Select card"/> </label> <button className="card-item__move-icon" onClick={handleMoveIconClick} title="Move this card to folder" aria-label="Move this card to folder">📁</button> {isLoading ? (<div className="card-item__spinner-container"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>) : ( <> <Link to={cardLink} preventScrollReset={true} style={{ textDecoration: 'none', zIndex: '2' }}> <img src={`/cards/${card.cardid}.${card.format}`} alt={card.cardname} className={`card-item__image ${card.setId > '0' ? 'card-item__image--set-temp' : ''}`}/> </Link> {card.score && card.score !== '?' && card.score !== '0' ? <div className="card-item__rating">{card.score}</div> : ''} </> )} </div> );};

// --- MoveToFolderModal Component (MODIFIED) ---
const MoveToFolderModal = ({ isOpen, onClose, folders, currentFolderIdForModal, onSelectFolder, itemName }) => {
  if (!isOpen) return null;

  // Filter for user-created, assignable folders.
  // These are folders that are not special (is_special: false or undefined)
  // and have a non-negative folder_id (folder_id >= 0).
  // 'Unassigned' (folder_id: null) is handled by the dedicated "Unassign" button.
  // Other special folders (e.g., 'All My Cards', 'Gallery Cards') are excluded.
  const assignableUserFolders = folders.filter(
    folder => !folder.is_special && folder.folder_id !== null && folder.folder_id >= 0
  ).sort((a, b) => (a.folder_order ?? Infinity) - (b.folder_order ?? Infinity));

  const handleUnassignClick = () => {
    onSelectFolder(null); // 'null' folder_id represents the "Unassigned" state
  };

  return (
    <div className="move-to-folder-modal__overlay" onClick={onClose}>
      <div className="move-to-folder-modal__content" onClick={(e) => e.stopPropagation()}>
        <h4>Move "{itemName}" to:</h4>

        {/* Dedicated Unassign Button */}
        <button
          onClick={handleUnassignClick}
          disabled={currentFolderIdForModal === null} // Disable if item(s) are already unassigned
          className={`move-to-folder-modal__unassign-btn ${currentFolderIdForModal === null ? 'current' : ''}`}
          // Basic styling to match list items, adjust in CSS as needed
          style={{ width: '100%', marginBottom: '10px', textAlign: 'left', padding: '10px', background: 'none', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer' }}
        >
          - Unassign -
          {currentFolderIdForModal === null && " (Current)"}
        </button>

        {assignableUserFolders.length > 0 && <hr style={{margin: '5px 0 10px 0'}} />} {/* Optional separator */}

        {assignableUserFolders.length > 0 ? (
          <ul className="move-to-folder-modal__list">
            {assignableUserFolders.map(folder => (
              <li key={`modal-folder-${folder.folder_id}`}>
                <button
                  onClick={() => onSelectFolder(folder.folder_id)}
                  disabled={folder.folder_id === currentFolderIdForModal}
                  className={folder.folder_id === currentFolderIdForModal ? 'current' : ''}
                >
                  {folder.folder_name} ({folder.card_count !== undefined ? folder.card_count : 'N/A'})
                  {folder.folder_id === currentFolderIdForModal && " (Current)"}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted" style={{paddingLeft: '10px'}}>No other user-created folders to move to.</p>
        )}
        <button className="move-to-folder-modal__close-btn" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};
// CreateFolderModal is NO LONGER NEEDED

// --- FolderSettingsModal Component (Updated for inline creation) ---
const FolderSettingsModal = React.memo(({ // Wrap with React.memo for performance
  show,
  onHide,
  initialFolders,
  onCreateFolder, // Renamed from onTriggerCreateFolder
  onDeleteFolder,
  onReorderFolders,
  onRenameFolder, 
  isLoadingReorder,
  isProcessingAction, 
}) => {
  const [managedFolders, setManagedFolders] = useState(initialFolders);
  const [editingFolderId, setEditingFolderId] = useState(null);
  const [editingFolderName, setEditingFolderName] = useState('');
  const [newFolderNameInput, setNewFolderNameInput] = useState(''); // For inline creation
  
  const renameInputRef = useRef(null);
  const createInputRef = useRef(null); // For new folder input

  useEffect(() => {
    if (!isLoadingReorder && !isProcessingAction) {
      setManagedFolders(initialFolders);
    }
  }, [initialFolders, isLoadingReorder, isProcessingAction]);

  useEffect(() => { // Focus rename input
    if (editingFolderId && renameInputRef.current) {
      renameInputRef.current.focus();
      renameInputRef.current.select();
    }
  }, [editingFolderId]);

  useEffect(() => { // Reset new folder input when modal closes or after creation
      if (!show) {
          setNewFolderNameInput('');
      }
  }, [show]);


  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) return;
    const reorderedFolders = Array.from(managedFolders);
    const [removed] = reorderedFolders.splice(source.index, 1);
    reorderedFolders.splice(destination.index, 0, removed);
    setManagedFolders(reorderedFolders);
    onReorderFolders(reorderedFolders.map(f => f.folder_id));
  };

  const startRename = (folder) => {
    if (isProcessingAction || isLoadingReorder) return;
    setEditingFolderId(folder.folder_id);
    setEditingFolderName(folder.folder_name);
  };

  const cancelRename = () => {
    setEditingFolderId(null);
    setEditingFolderName('');
  };

  const handleRenameSubmit = async (folderId) => {
    if (!editingFolderName.trim() || editingFolderName === managedFolders.find(f => f.folder_id === folderId)?.folder_name) {
      cancelRename();
      return;
    }
    await onRenameFolder(folderId, editingFolderName.trim());
    cancelRename(); 
  };
  
  const handleRenameKeyDown = (e, folderId) => {
    if (e.key === 'Enter') { e.preventDefault(); handleRenameSubmit(folderId); } 
    else if (e.key === 'Escape') { e.preventDefault(); cancelRename(); }
  };

  const handleCreateNewFolder = async (e) => {
    e.preventDefault(); // If called from form submit
    if (!newFolderNameInput.trim()) return;
    await onCreateFolder(newFolderNameInput.trim());
    setNewFolderNameInput(''); // Clear input after submission
    if(createInputRef.current) createInputRef.current.focus(); // Re-focus for next creation
  };

  return (
    <Modal show={show} onHide={onHide} centered scrollable>
      <Modal.Header closeButton> <Modal.Title><FaCog className="me-2" />Folder Settings</Modal.Title> </Modal.Header>
      <Modal.Body>
        {/* Inline Folder Creation */}
        <Form onSubmit={handleCreateNewFolder} className="mb-3">
          <InputGroup>
            <Form.Control
              ref={createInputRef}
              type="text"
              placeholder="New Folder Name..."
              value={newFolderNameInput}
              onChange={(e) => setNewFolderNameInput(e.target.value)}
              disabled={isLoadingReorder || isProcessingAction}
              aria-label="New folder name"
              maxLength={40}
            />
            <Button 
              variant="success" 
              onClick={handleCreateNewFolder} 
              disabled={!newFolderNameInput.trim() || isLoadingReorder || isProcessingAction}
              title="Create new folder"
            >
              <FaPlus /> <span className="d-none d-sm-inline ms-1"></span>
            </Button>
          </InputGroup>
        </Form>
        
        <h5 className="mt-4 mb-2">Manage & Reorder Folders</h5>
        {(isLoadingReorder || isProcessingAction) && <Alert variant="info" className="py-2 d-flex align-items-center"><Spinner animation="border" size="sm" className="me-2" />Processing...</Alert>}
        
        {managedFolders.length === 0 ? ( <Alert variant="info">No user-created folders yet.</Alert> ) : (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-user-folders">
              {(provided) => (
                <ListGroup {...provided.droppableProps} ref={provided.innerRef}>
                  {managedFolders.map((folder, index) => (
                    <Draggable key={String(folder.folder_id)} draggableId={String(folder.folder_id)} index={index} isDragDisabled={isLoadingReorder || isProcessingAction || editingFolderId === folder.folder_id}>
                      {(providedDraggable, snapshot) => (
                        <ListGroup.Item ref={providedDraggable.innerRef} {...providedDraggable.draggableProps} className={`d-flex align-items-center ${snapshot.isDragging ? 'dragging-item' : ''}`} style={{ ...providedDraggable.draggableProps.style }}>
                          <span {...providedDraggable.dragHandleProps} className="me-2" style={{ cursor: 'grab', lineHeight: 1, display: 'flex', alignItems: 'center' }} title={`Drag to reorder: ${folder.folder_name}`}> <BsGripVertical size={18} /> </span>
                          {editingFolderId === folder.folder_id ? (
                            <Form.Control
                              ref={renameInputRef} type="text" size="sm" value={editingFolderName}
                              onChange={(e) => setEditingFolderName(e.target.value)}
                              onBlur={() => handleRenameSubmit(folder.folder_id)} 
                              onKeyDown={(e) => handleRenameKeyDown(e, folder.folder_id)}
                              className="me-2 flex-grow-1" disabled={isProcessingAction}
                              maxLength={40}
                            />
                          ) : (
                            <span title={folder.folder_name} className="flex-grow-1 me-2 text-truncate" onDoubleClick={() => startRename(folder)} style={{cursor: 'pointer'}}> {folder.folder_name} ({folder.card_count ?? '?'}) </span>
                          )}
                          <div className="ms-auto d-flex align-items-center">
                            {editingFolderId === folder.folder_id ? (
                                <>
                                <Button variant="link" size="sm" onClick={() => handleRenameSubmit(folder.folder_id)} title="Save name" disabled={isProcessingAction} className="p-1 me-1"><FaSave color="green"/></Button>
                                <Button variant="link" size="sm" onClick={cancelRename} title="Cancel rename" disabled={isProcessingAction} className="p-1"><FaUndo color="orange"/></Button>
                                </>
                            ) : (
                                <Button variant="link" size="sm" onClick={() => startRename(folder)} title={`Rename "${folder.folder_name}"`} className="p-1 me-1" disabled={isLoadingReorder || isProcessingAction}><FaEdit /></Button>
                            )}
                            <Button variant="link" size="sm" onClick={() => onDeleteFolder(folder.folder_id, folder.folder_name)} title={`Delete folder "${folder.folder_name}"`} disabled={isLoadingReorder || isProcessingAction || editingFolderId === folder.folder_id} className="p-1 text-danger"> <FaTrash /> </Button>
                          </div>
                        </ListGroup.Item>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ListGroup>
              )}
            </Droppable>
          </DragDropContext>
        )}
        {managedFolders.length > 0 && <p className="text-muted small mt-2">Drag using <BsGripVertical style={{verticalAlign: 'middle'}}/>. Double-click name or use <FaEdit style={{verticalAlign: 'middle'}}/> to rename.</p>}
      </Modal.Body>
      <Modal.Footer> <Button variant="secondary" onClick={onHide} disabled={isLoadingReorder || isProcessingAction}> Close </Button> </Modal.Footer>
    </Modal>
  );
});

const ORGANIZER_CLASSES = [
    { label: "All Classes", value: "", image: "../images/cardclass.png" }, // Default icon for "All Classes" or when no specific class is selected
    { label: "Death Knight", value: "DeathKnight", image: "/gallery/images/class-icons/death-knight.png" },
    { label: "Demon Hunter", value: "Demon Hunter", image: "/gallery/images/class-icons/demon-hunter.png" },
    { label: "Druid", value: "Druid", image: "/gallery/images/class-icons/druid.png" },
    { label: "Hunter", value: "Hunter", image: "/gallery/images/class-icons/hunter.png" },
    { label: "Mage", value: "Mage", image: "/gallery/images/class-icons/mage.png" },
    { label: "Paladin", value: "Paladin", image: "/gallery/images/class-icons/paladin.png" },
    { label: "Priest", value: "Priest", image: "/gallery/images/class-icons/priest.png" },
    { label: "Rogue", value: "Rogue", image: "/gallery/images/class-icons/rogue.png" },
    { label: "Shaman", value: "Shaman", image: "/gallery/images/class-icons/shaman.png" },
    { label: "Warlock", value: "Warlock", image: "/gallery/images/class-icons/warlock.png" },
    { label: "Warrior", value: "Warrior", image: "/gallery/images/class-icons/warrior.png" },
    { label: "Neutral", value: "Neutral", image: "/gallery/images/class-icons/neutral.png" }
  ];

const ALL_MY_CARDS_FOLDER_ID = -4; 

// --- UserCardOrganizer Component ---
const UserCardOrganizer = ({ settings, filters: propFilters }) => {
  const { user, organizerDataVersion } = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  const [folders, setFolders] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(undefined); 
  const [cards, setCards] = useState([]);
  const [isLoadingCards, setIsLoadingCards] = useState(false);
  const [isLoadingFolders, setIsLoadingFolders] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);
  const [cardToMove, setCardToMove] = useState(null);
  const [selectedCardIds, setSelectedCardIds] = useState(new Set());
  // isCreateFolderModalOpen is no longer needed
  const [showFolderSettingsModal, setShowFolderSettingsModal] = useState(false);
  const [isLoadingReorder, setIsLoadingReorder] = useState(false);
  const [isProcessingFolderAction, setIsProcessingFolderAction] = useState(false);

  const [currentFilters, setCurrentFilters] = useState(() => { 
    const params = new URLSearchParams(location.search); 
    return { 
      search: params.get('search') || propFilters?.search || '', 
      class: params.get('class') || propFilters?.class || '', 
      cost: params.get('cost') || propFilters?.cost || '', 
      cardtype: params.get('cardtype') || propFilters?.cardtype || '', 
      rarity: params.get('rarity') || propFilters?.rarity || '', 
      order: params.get('order') || propFilters?.order || 'date_desc', 
      startDate: params.get('startDate') || propFilters?.startDate || '', 
      endDate: params.get('endDate') || propFilters?.endDate || '', 
    }; 
  });
  const searchInputTopPanelRef = useRef(null);
  const [topPanelSearchTerm, setTopPanelSearchTerm] = useState(currentFilters.search || '');


  useEffect(() => { 
    if (currentFilters.search !== topPanelSearchTerm) { 
      setTopPanelSearchTerm(currentFilters.search || ''); 
    } 
  }, [currentFilters.search]);
  

  const cardsPerRow = settings?.cardsPerRow || 5;
  const cardsPerPage = settings?.cardsPerPage || 40;
  const REFETCH_TRIGGER_FILTER_KEYS = ['search', 'class', 'cost', 'cardtype', 'rarity', 'order', 'startDate', 'endDate'];

  useEffect(() => { 
    const params = new URLSearchParams(location.search); 
    const newUrlFilters = {}; 
    REFETCH_TRIGGER_FILTER_KEYS.forEach(key => { 
      newUrlFilters[key] = params.get(key) || (propFilters?.[key] || ''); 
    }); 
    if (newUrlFilters.order === '') newUrlFilters.order = 'date_desc'; 
    
    let filtersHaveChanged = false; 
    for (const key of REFETCH_TRIGGER_FILTER_KEYS) { 
      if (currentFilters[key] !== newUrlFilters[key]) { 
        filtersHaveChanged = true; break; 
      } 
    } 
    if (filtersHaveChanged) { 
      setCurrentFilters(prevFilters => ({...prevFilters, ...newUrlFilters})); 
    } 
    const pageFromUrl = parseInt(params.get('page'), 10) || 1; 
    if (currentPage !== pageFromUrl) { 
      setCurrentPage(pageFromUrl); 
    } 
  }, [location.search, propFilters, cardsPerPage, settings]);

  const apiQueryFilters = currentFilters;

  const fetchFolders = useCallback(async (options = {}) => {
    if (!user) { setIsLoadingFolders(false); return; }
    const { makeSelectedId, preserveCurrentSelection } = options;
    setIsLoadingFolders(true);
    try {
      const response = await fetch('/api/organizer/get_user_folders.php');
      const data = await response.json();
      let newFolders = (data.folders && Array.isArray(data.folders))
        ? data.folders.sort((a, b) => (a.folder_order ?? Infinity) - (b.folder_order ?? Infinity))
        : [ { folder_id: ALL_MY_CARDS_FOLDER_ID, folder_name: 'All Cards', card_count: 0, is_special: true, folder_order: 0 }, { folder_id: null, folder_name: 'Unassigned Cards', card_count: 0, is_special: true, folder_order: 1 }, { folder_id: -1, folder_name: 'Gallery Cards', card_count: 0, is_special: true, folder_order: 2 }, { folder_id: -2, folder_name: 'In Queue', card_count: 0, is_special: true, folder_order: 3 }].sort((a,b)=>a.folder_order - b.folder_order);
      setFolders(newFolders);

      let newSelectedFolderIdToSet = selectedFolderId;
      if (makeSelectedId !== undefined) {
        newSelectedFolderIdToSet = makeSelectedId;
      } else if (!preserveCurrentSelection && selectedFolderId === undefined && newFolders.length > 0) {
        const allMyCards = newFolders.find(f => f.folder_id === ALL_MY_CARDS_FOLDER_ID);
        newSelectedFolderIdToSet = allMyCards ? allMyCards.folder_id : (newFolders.find(f=>f.folder_id === null)?.folder_id ?? newFolders[0]?.folder_id ?? null);
      } else if (!preserveCurrentSelection && newFolders.length > 0 && !newFolders.some(f => f.folder_id === selectedFolderId)) {
        const allMyCards = newFolders.find(f => f.folder_id === ALL_MY_CARDS_FOLDER_ID);
        newSelectedFolderIdToSet = allMyCards ? allMyCards.folder_id : (newFolders.find(f=>f.folder_id === null)?.folder_id ?? newFolders[0]?.folder_id ?? null);
      } else if (newFolders.length === 0) {
        newSelectedFolderIdToSet = null;
      }
      if (selectedFolderId === undefined || newSelectedFolderIdToSet !== selectedFolderId) {
        setSelectedFolderId(newSelectedFolderIdToSet);
      }
    } catch (error) { 
      console.error('Failed to fetch folders:', error); 
      setFolders([ { folder_id: ALL_MY_CARDS_FOLDER_ID, folder_name: 'All Cards', card_count: 0, is_special: true, folder_order: 0 }, { folder_id: null, folder_name: 'Unassigned Cards', card_count: 0, is_special: true, folder_order: 1 } ]); 
      setSelectedFolderId(ALL_MY_CARDS_FOLDER_ID);
    } finally { 
      setIsLoadingFolders(false); 
    }
  }, [user, selectedFolderId]);

  const fetchCards = useCallback(async (folderIdToFetch, pageToFetch) => { 
    if (!user || folderIdToFetch === undefined) { setCards([]); setTotalPages(0); return; } 
    setIsLoadingCards(true); 
    const queryParams = new URLSearchParams({ folder_id: folderIdToFetch === null ? 'null' : folderIdToFetch.toString(), page: pageToFetch, perPage: cardsPerPage, ...apiQueryFilters }); 
    for (const [key, value] of Array.from(queryParams.entries())) { if (!value) { queryParams.delete(key); } } 
    try { 
      const response = await fetch(`/api/organizer/get_cards_in_folder.php?${queryParams.toString()}`); 
      const data = await response.json(); 
      if (data.cards) { setCards(data.cards); setTotalPages(data.main.maxpage || 0); } 
      else { console.error("Error fetching cards:", data.error || "No cards data returned"); setCards([]); setTotalPages(0); } 
    } catch (error) { console.error('Failed to fetch cards:', error); setCards([]); setTotalPages(0); } 
    setIsLoadingCards(false); 
  }, [user, apiQueryFilters, cardsPerPage]); 
  
  useEffect(() => { 
    if (user) { fetchFolders(); } 
  }, [user, fetchFolders]); // fetchFolders is memoized, so this is fine.
  
  useEffect(() => { 
    if (selectedFolderId !== undefined && user && currentPage > 0) { 
      fetchCards(selectedFolderId, currentPage); 
    } 
  }, [selectedFolderId, currentPage, user, apiQueryFilters, fetchCards]); // Added fetchCards

  // --- Add a ref to track the initial mount ---
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    fetchFolders({ preserveCurrentSelection: true });

    if (cards.length === 1 && currentPage > 1) {
      handlePageChange(currentPage - 1);
    } else {
      if (selectedFolderId !== undefined && user && currentPage > 0) {
        fetchCards(selectedFolderId, currentPage);
      }
    }
  }, [organizerDataVersion]);

  const updateUrlParamsAndNavigate = (newParams, resetPage = false) => { 
    const currentUrlParams = new URLSearchParams(location.search); 
    const paramsToSet = { ...currentFilters, ...newParams }; 
    for (const key in paramsToSet) { 
      if (REFETCH_TRIGGER_FILTER_KEYS.includes(key) || key === 'page') { 
        if (paramsToSet[key] === '' || paramsToSet[key] === null || paramsToSet[key] === undefined) { 
          currentUrlParams.delete(key); 
        } else { 
          currentUrlParams.set(key, String(paramsToSet[key])); 
        } 
      } 
    } 
    if (resetPage) { currentUrlParams.set('page', '1'); } 
    else if (!currentUrlParams.has('page')) { 
      currentUrlParams.set('page', String(currentPage)); 
    }
    const selectedCardVal = new URLSearchParams(location.search).get('selectedCard'); 
    if (selectedCardVal) { currentUrlParams.set('selectedCard', selectedCardVal); } 
    navigate(`${location.pathname}?${currentUrlParams.toString()}`, { replace: true, preventScrollReset: true }); 
  };
  
  const handleFilterChange = (newFiltersFromDropdown) => { 
    setSelectedCardIds(new Set()); 
    const updatedFilters = { ...currentFilters, ...newFiltersFromDropdown }; 
    setCurrentFilters(updatedFilters); 
    updateUrlParamsAndNavigate(updatedFilters, true); 
  };
  
  const handleResetFilters = () => { 
    const defaultFilters = { search: '', class: '', cost: '', cardtype: '', rarity: '', order: 'date_desc', startDate: '', endDate: '' }; 
    setTopPanelSearchTerm(''); 
    setCurrentFilters(defaultFilters); 
    updateUrlParamsAndNavigate(defaultFilters, true); 
  };
  
  const handleTopPanelSearchChange = (e) => { setTopPanelSearchTerm(e.target.value); };
  const triggerTopPanelSearchFilter = () => { if (topPanelSearchTerm !== (currentFilters.search || '')) { handleFilterChange({ search: topPanelSearchTerm }); } };
  const handleTopPanelSearchBlur = () => { triggerTopPanelSearchFilter(); };
  const handleTopPanelSearchFormSubmit = (e) => { e.preventDefault(); triggerTopPanelSearchFilter(); searchInputTopPanelRef.current?.blur(); };
  const clearTopPanelSearch = () => { setTopPanelSearchTerm(''); handleFilterChange({ search: '' }); searchInputTopPanelRef.current?.focus(); };
  const handleTopPanelClassChange = (classValue) => { handleFilterChange({ class: classValue }); };
  const handlePageChange = (newPage) => { if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) { setCurrentPage(newPage); updateUrlParamsAndNavigate({ page: newPage.toString() }); } };
  
  const handleSelectFolder = (event) => { 
    const newFolderIdStr = event.target.value; 
    let newFolderId; 
    if (newFolderIdStr === 'null') newFolderId = null; 
    else if (newFolderIdStr === 'SEPARATOR') return; 
    else newFolderId = parseInt(newFolderIdStr, 10); 
    if (newFolderId !== selectedFolderId) { 
      setSelectedCardIds(new Set()); 
      setSelectedFolderId(newFolderId); 
      setCurrentPage(1); 
      updateUrlParamsAndNavigate({ ...currentFilters }, true); 
    } 
  };
  
  const handleCardSelectionChange = useCallback((cardId) => { setSelectedCardIds(prevSelected => { const newSelected = new Set(prevSelected); if (newSelected.has(cardId)) { newSelected.delete(cardId); } else { newSelected.add(cardId); } return newSelected; }); }, []);
  const handleDeselectAll = () => setSelectedCardIds(new Set());
  const handleSelectAllVisible = () => { const newSelectedCardIds = new Set(selectedCardIds); cards.forEach(card => newSelectedCardIds.add(card.id)); setSelectedCardIds(newSelectedCardIds); };
  const openFolderSettingsModal = () => setShowFolderSettingsModal(true);
  const closeFolderSettingsModal = () => { setShowFolderSettingsModal(false); };
  // openCreateFolderModal and closeCreateFolderModal are no longer needed

  const handleCreateFolder = async (folderNameFromModal) => { 
    if (!user || !folderNameFromModal.trim()) return;
    setIsProcessingFolderAction(true); 
    try { 
      const response = await fetch('/api/organizer/create_folder.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ folderName: folderNameFromModal }), });
      const data = await response.json(); 
      if (data.success) { 
        // No need to close a separate modal
        await fetchFolders({ makeSelectedId: data.folder_id, preserveCurrentSelection: false }); // Select the new folder
        setCurrentPage(1); 
        updateUrlParamsAndNavigate({ ...currentFilters }, true); 
      } else { 
        alert(`Error: ${data.error}`); 
      }
    } catch (error) { 
      console.error('Failed to create folder:', error); 
      alert('Client-side: Failed to create folder.');
    } finally { 
      setIsProcessingFolderAction(false); 
    }
  };

  const handleDeleteFolder = async (folderIdToDelete, folderName) => { 
    if (!user || folderIdToDelete === null || folderIdToDelete < 0) { alert("Cannot delete special folders."); return; }
    if (!window.confirm(`Are you sure you want to delete the folder "${folderName}"? All cards within it will become unassigned.`)) return;
    setIsProcessingFolderAction(true); 
    try { 
      const response = await fetch('/api/organizer/delete_folder.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ folder_id: folderIdToDelete }), });
      const data = await response.json(); 
      if (data.success) { 
        const newSelectedId = selectedFolderId === folderIdToDelete ? ALL_MY_CARDS_FOLDER_ID : selectedFolderId; 
        await fetchFolders({ makeSelectedId: newSelectedId, preserveCurrentSelection: selectedFolderId !== folderIdToDelete }); 
        if (selectedFolderId === folderIdToDelete) { 
          setCurrentPage(1); 
          updateUrlParamsAndNavigate({ ...currentFilters }, true); 
        } 
      } else { 
        alert(`Error deleting folder: ${data.error || 'Unknown error'}`); 
      }
    } catch (error) { 
      console.error('Failed to delete folder:', error); 
      alert('Client-side: Failed to delete folder.');
    } finally { 
      setIsProcessingFolderAction(false); 
    }
  };

  const handleReorderFolders = async (orderedFolderIds) => { 
    if (!user) return;
    setIsLoadingReorder(true); 
    try { 
      const response = await fetch('/api/organizer/reorder_folders.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ordered_folder_ids: orderedFolderIds }), });
      const data = await response.json();
      if (data.success) {
        await fetchFolders({ preserveCurrentSelection: true }); 
      } else {
        alert(`Error reordering folders: ${data.error || 'Unknown error'}`);
        await fetchFolders({ preserveCurrentSelection: true }); 
      }
    } catch (error) { 
      console.error('Client-side error reordering folders:', error); 
      alert('Client-side error: Failed to reorder folders.');
      await fetchFolders({ preserveCurrentSelection: true }); 
    } finally { 
      setIsLoadingReorder(false); 
    }
  };
  
  const handleRenameFolder = async (folderIdToRename, newName) => {
    if (!user) return;
    setIsProcessingFolderAction(true);
    try {
      const response = await fetch('/api/organizer/rename_folder.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ folder_id: folderIdToRename, newFolderName: newName }),
      });
      const data = await response.json();
      if (data.success) {
        await fetchFolders({ preserveCurrentSelection: true }); 
      } else {
        alert(`Error renaming folder: ${data.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Client-side error renaming folder:', error);
      alert('Client-side error: Failed to rename folder.');
    } finally {
      setIsProcessingFolderAction(false);
    }
  };

  const openSingleCardMoveModal = (card) => { setCardToMove(card); setSelectedCardIds(new Set()); setIsMoveModalOpen(true); };
  const openMassMoveModal = () => { if (selectedCardIds.size === 0) return; setCardToMove(null); setIsMoveModalOpen(true); };
  const closeMoveModal = () => { setIsMoveModalOpen(false); setCardToMove(null); };
  
  const handleConfirmMoveToFolder = async (targetFolderId) => { 
    let idsToMove = []; let isMassMove = false;
    if (selectedCardIds.size > 0 && !cardToMove) { idsToMove = Array.from(selectedCardIds); isMassMove = true; }
    else if (cardToMove && selectedCardIds.size === 0) { idsToMove = [cardToMove.id]; }
    else { closeMoveModal(); return; }
    if (idsToMove.length === 0) { closeMoveModal(); return; }
    try { 
      const response = await fetch('/api/organizer/move_card_to_folder.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ card_ids: idsToMove, new_folder_id: targetFolderId }), });
      const data = await response.json(); 
      if (data.success) { 
        await fetchCards(selectedFolderId, currentPage); 
        await fetchFolders({ preserveCurrentSelection: true }); 
        if (isMassMove) setSelectedCardIds(new Set()); 
      } else { 
        alert(`Error moving card(s): ${data.error || 'Unknown error'}`); 
      }
    } catch (error) { 
      console.error('Client-side error moving card(s):', error); 
      alert('Client-side error: Failed to move card(s).');
    } 
    closeMoveModal(); 
  };

  if (!user) return <p className="user-organizer-message">Please log in to organize your cards.</p>;
  if (isLoadingFolders && selectedFolderId === undefined) { return <div className="user-organizer-message d-flex align-items-center justify-content-center" style={{minHeight: '200px'}}><Spinner animation="border" className="me-2" />Initializing folders...</div>; }

  const currentFolderObject = folders.find(f => f.folder_id === selectedFolderId);
  const currentFolderName = currentFolderObject?.folder_name || (isLoadingFolders ? 'Loading...' : 'Select a folder');
  const specialFolders = folders.filter(f => f.is_special);
  const userCreatedFolders = folders.filter(f => !f.is_special && f.folder_id !== null && f.folder_id >= 0);

  const selectedClassFilterValue = currentFilters.class || ""; // Default to "All Classes" if no class is set
  const selectedClassForIcon = ORGANIZER_CLASSES.find(c => c.value === selectedClassFilterValue);
  const classIconSrc = selectedClassForIcon && selectedClassForIcon.image 
                       ? selectedClassForIcon.image 
                       : "../images/cardclass.png"; // Fallback to default icon
  const classIconAlt = selectedClassForIcon && selectedClassForIcon.label 
                       ? selectedClassForIcon.label 
                       : "Class Filter";

  return (
    <>
      <div className="user-card-organizer">
      <div className="folders-top-panel mx-sm-4 mx-0 mt-4 rounded d-flex align-items-center flex-nowrap">
  {/*
    1. folder-controls:
       - d-flex align-items-center: For its children (button, select).
       - flex-grow-1: Allow this section to take available space.
       - flex-shrink-1: Allow this section to shrink.
       - min-width: 0: CRUCIAL for allowing it to shrink below its content's intrinsic minimum size.
  */}
  <div
    className="folder-controls d-flex align-items-center me-2"
    style={{ flexGrow: 1, flexShrink: 1, minWidth: 0 }}
  >
    <label htmlFor="folderSelect" className="sr-only">Select Folder</label>
    {/* Button should not shrink/grow, it has a fixed size */}
    <Button variant="link" className="top-panel-btn p-0 ms-1 flex-shrink-0" onClick={openFolderSettingsModal} title="Folder Settings" aria-label="Folder Settings" disabled={isLoadingFolders}>
      <FaCog style={{ width: '20px', height: '20px', color: 'white' }}/>
    </Button>
    <select
      id="folderSelect"
      // Add Bootstrap's form-select for better default styling and responsiveness
      // You might need form-select-sm if other inputs are size="sm"
      className="folder-select form-select form-select-sm"
      style={{
        flexGrow: 1,      // Allow the select to grow to fill folder-controls
        flexShrink: 1,    // Allow the select to shrink
        minWidth: '100px', // A sensible minimum width for the select itself. Adjust as needed.
        maxWidth: '250px',                   // Could be a percentage like '50px' or '30%' if its parent has a defined behavior.
                           // Or even smaller like '80px' if text is short.
        // width: '100%' // This tells the select to try and be as wide as its parent.
                          // Combined with parent's min-width:0 and flex properties, it should work.
                          // Often, just flex-grow: 1 on the select, and min-width:0 on its flex parent is enough.
      }}
      value={selectedFolderId === null ? 'null' : String(selectedFolderId)}
      onChange={handleSelectFolder}
      disabled={isLoadingFolders || selectedFolderId === undefined}
      aria-label="Select folder"
    >
      {selectedFolderId === undefined && isLoadingFolders ? ( <option value="">Loading...</option> ) : (
        <>
          {specialFolders.map(folder => ( <option key={folder.folder_id === null ? `sfolder-null` : `sfolder-${folder.folder_id}`} value={folder.folder_id === null ? 'null' : String(folder.folder_id)}> {folder.folder_name} ({folder.card_count ?? '?'}) </option>))}
          {userCreatedFolders.length > 0 && specialFolders.length > 0 && ( <option disabled value="SEPARATOR" className="folder-select-separator">- User Folders -</option> )}
          {userCreatedFolders.map(folder => ( <option key={`ufolder-${folder.folder_id}`} value={String(folder.folder_id)}> {folder.folder_name} ({folder.card_count ?? '?'}) </option>))}
          {folders.length === 0 && !isLoadingFolders && <option value="">No folders available</option>}
        </>
      )}
    </select>
  </div>

  {selectedCardIds.size > 0 && (
    // This section should not grow, and only shrink if absolutely necessary.
    // flex-shrink-0 prevents it from shrinking easily.
    <div className="mass-action-controls d-none d-md-flex align-items-center me-2 flex-shrink-0">
      <span className="selected-count-text me-2 text-nowrap">{selectedCardIds.size} card(s) selected</span>
      <Button onClick={openMassMoveModal} size="sm" className="top-panel-btn top-panel-btn--move me-1">Move</Button>
      <Button onClick={handleSelectAllVisible} size="sm" className="top-panel-btn top-panel-btn--select-all me-1">Select All</Button>
      <Button onClick={handleDeselectAll} size="sm" className="top-panel-btn top-panel-btn--deselect-all">Deselect All</Button>
    </div>
  )}

  {/*
    2. filters-container:
       - ms-auto: Pushes it to the right.
       - d-flex align-items-center: For its children.
       - flex-shrink-1: Allow this section to shrink if needed.
       - min-width: 0: Allow it to shrink below its content's intrinsic size.
  */}
  <div className="filters-container ms-auto d-flex align-items-center" style={{ flexShrink: 1, minWidth: 0 }}>
    {/*
      3. inline-filters-section (contains search and class filter):
         - d-flex align-items-center: For its children.
         - flex-grow-1: Allow this inner section to take available space within filters-container.
         - flex-shrink-1: Allow it to shrink.
         - min-width: 0: Allow it to shrink below its content's intrinsic size.
    */}
    {/* me-1 */}
    <div className="inline-filters-section d-flex align-items-center" style={{ flexGrow: 1, flexShrink: 1, minWidth: 0 }}>
      {/* Form should be d-flex and allow its child (InputGroup) to grow */}
      <Form onSubmit={handleTopPanelSearchFormSubmit} className="d-flex flex-grow-1">
        <InputGroup
          size="sm"
          className="top-panel-search-group" // flex-grow-1 on parent Form handles width for InputGroup
          style={{
            minWidth: '80px', // Minimum sensible width for search.
            flexGrow: 1,      // Allow search input to take space.
            flexShrink: 1,    // Allow search input to shrink.
          }}
        >
          <Form.Control
            ref={searchInputTopPanelRef}
            type="search"
            placeholder="Search" // Shorter placeholder
            value={topPanelSearchTerm}
            onChange={handleTopPanelSearchChange}
            onBlur={handleTopPanelSearchBlur}
            className="top-panel-search-form-control" // Ensure this class isn't setting a conflicting width
          />
          {topPanelSearchTerm && (<Button variant="link" onClick={clearTopPanelSearch} className="search-clear-btn-global" aria-label="Clear search"><FaTimes /></Button>)}
        </InputGroup>
      </Form>
      {/* Dropdown button should not shrink */}
      <Dropdown className="ms-2 flex-shrink-0">
        <Dropdown.Toggle variant="none" size="sm" id="top-panel-class-filter-toggle" className="top-panel-filter-button p-0 pe-1" style={{ border: 'unset' }}>
          <img src={classIconSrc} className="icon-img" style={{ width: '24px', height: '24px' }} alt={classIconAlt}/>
          {/* <FaChevronDown size={14} color="white" style={{ stroke: 'black', strokeWidth: '40', paddingTop: '3px', paddingLeft: '4px' }} /> */}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {ORGANIZER_CLASSES.map(opt => ( <Dropdown.Item key={`tp-cl-${opt.value}`} onClick={() => handleTopPanelClassChange(opt.value)}>{opt.label}</Dropdown.Item>))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
    {/* Your commented-out FiltersDropdown */}
  </div>
</div>
        <main className="organizer-content">
            <div className={`cards-display-area cards-per-row-${cardsPerRow}`}>
                {isLoadingCards ? ( Array.from({ length: Math.min(cardsPerPage, 12) }).map((_, index) => ( <div className="card-item card-item--placeholder" aria-hidden="true" key={`placeholder-${index}`}> <div className="card-item__spinner-container"><Spinner animation="border" variant="primary" role="status"><span className="visually-hidden">Loading...</span></Spinner></div> </div> )) ) :
                 cards.length > 0 ? ( cards.map((card) => ( <CardDisplay key={card.id} card={card} onMoveClick={openSingleCardMoveModal} isSelected={selectedCardIds.has(card.id)} onSelectChange={handleCardSelectionChange} /> )) ) :
                 ( <p className="no-cards-message">No cards found with the current filters in "{currentFolderName}".</p> )}
            </div>
       </main>
      </div>
      {!isLoadingCards && cards.length > 0 && totalPages > 1 && ( <div> <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /> </div> )}
      
      <MoveToFolderModal isOpen={isMoveModalOpen} onClose={closeMoveModal} folders={folders} currentFolderIdForModal={(selectedCardIds.size > 0 && !cardToMove) ? selectedFolderId : (cardToMove ? cardToMove.folder_id : null)} onSelectFolder={handleConfirmMoveToFolder} itemName={(selectedCardIds.size > 0 && !cardToMove) ? `${selectedCardIds.size} selected card(s)` : (cardToMove ? cardToMove.cardname || 'Card' : 'Card')} />
      {/* CreateFolderModal is no longer rendered here */}
      <FolderSettingsModal
        show={showFolderSettingsModal}
        onHide={closeFolderSettingsModal}
        initialFolders={userCreatedFolders}
        onCreateFolder={handleCreateFolder} // Pass the main create folder handler
        onDeleteFolder={handleDeleteFolder}
        onReorderFolders={handleReorderFolders}
        onRenameFolder={handleRenameFolder}
        isLoadingReorder={isLoadingReorder}
        isProcessingAction={isProcessingFolderAction}
      />

      {/* Mobile Action Bar - For XS and SM screens */}
      {selectedCardIds.size > 0 && (
        <div className="mobile-action-bar d-md-none"> {/* d-md-none: visible on xs, sm; hidden on md+ */}
          <span className="mobile-selected-count">
            {selectedCardIds.size} selected
          </span>
          <div className="mobile-action-buttons">
            <Button onClick={openMassMoveModal} variant="primary" size="sm">Move</Button>
            <Button onClick={handleDeselectAll} variant="outline-secondary" size="sm">Deselect</Button>
          </div>
        </div>
      )}

    </>
  );
};

export default UserCardOrganizer;